"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentFieldMapper = contentFieldMapper;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _Loader = _interopRequireDefault(require("@civicplus/preamble/lib/Loader/Loader"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _TypeGuards = require("../Utility/TypeGuards");

var LoadableAssetField = (0, _reactLoadable["default"])({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2["default"])(require("../AssetField/AssetField"));
    });
  },
  loading: function loading() {
    return /*#__PURE__*/_react["default"].createElement(_Loader["default"], null);
  }
});
var LoadableReferencesField = (0, _reactLoadable["default"])({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2["default"])(require("../ContentFlow/Fields/ReferenceField"));
    });
  },
  loading: function loading() {
    return /*#__PURE__*/_react["default"].createElement(_Loader["default"], null);
  }
});

function contentFieldMapper(props) {
  var field = props.field,
      config = props.config;

  if (field.properties.fieldType === "Assets") {
    return function (params) {
      var _field$label;

      return {
        component: LoadableAssetField,
        value: params.value,
        config: config,
        name: field.name,
        disabled: params.disabled,
        label: (_field$label = field.label) !== null && _field$label !== void 0 ? _field$label : field.name,
        onChange: function onChange(value) {
          var event = value[0];
          return {
            value: event.target.value
          };
        }
      };
    };
  }

  if ((0, _TypeGuards.isReferences)(field.properties)) {
    return function (params) {
      var _field$label2, _field$properties$con;

      return {
        component: LoadableReferencesField,
        value: params.value || [],
        config: config,
        name: field.name,
        disabled: params.disabled,
        label: (_field$label2 = field.label) !== null && _field$label2 !== void 0 ? _field$label2 : field.name,
        schema: (_field$properties$con = field.properties.contentTypeIds) === null || _field$properties$con === void 0 ? void 0 : _field$properties$con[0],
        onChange: function onChange(value) {
          var event = value[0];
          return {
            value: event.target.value
          };
        }
      };
    };
  }

  return null;
}